import React from 'react';
import { pick } from 'lodash';
import { Row, Col } from 'react-flexbox-grid';

import {
  FormControl as MuiFormControl,
  FormControlLabel as MuiFormControlLabel,
  RadioGroup,
  Radio,
  withStyles,
} from '@material-ui/core';
import { Button, DatePicker } from 'shared/components';

import FilterItem from '../../components/FilterItem';
import theme from './FilterByDateRange.scss';

const FormControl = withStyles({
  root: {
    marginTop: 15,
  },
})(MuiFormControl);

const FormControlLabel = withStyles({
  label: {
    fontSize: 18,
  },
})(MuiFormControlLabel);

const FilterByDateRange = ({
  intl,
  daterangeTypes,
  daterangeType,
  setDateRangeType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setTodayDate,
  setThisWeekDate,
  setThisMonthDate,
  ...rest
}) => {
  const filterItemProps = pick(rest, ['expanded', 'onChange', 'label', 'description']);
  const radioLabel = intl.formatMessage({ id: 'Appointments.AppointmentsList.Filter.FilterOption.Date.Title', defaultMessage: '** Date' });

  return (
    <FilterItem { ...filterItemProps }>
      <div className={ theme.root }>

        <FormControl component="fieldset">
          <RadioGroup
            aria-label={ radioLabel }
            value={ daterangeType }
            onChange={ (event) => setDateRangeType(event.target.value) }
            row
          >
            { daterangeTypes.map(({ key, label }) => (
              <FormControlLabel key={ key } value={ key } control={ <Radio color="primary" /> } label={ intl.formatMessage(label) } />
            )) }
          </RadioGroup>
        </FormControl>

        <div>
          <Button
            className={ theme.button }
            testId="set-today-date-daterange"
            tabIndex={ rest.expanded ? 0 : -1 }
            buttonType="naked"
            ariaLabel={ intl.formatMessage({ id: 'GeneralDateFilter.TodayButton.TitleAttribute', defaultMessage: '** Set date filter to today’s date' }) }
            label={ intl.formatMessage({ id: 'Appointments.AppointmentsList.Filter.Schedule.Today', defaultMessage: '** Today' }) }
            size="xsmall"
            onClick={ setTodayDate }
          />
          <Button
            className={ theme.button }
            testId="set-this-week-daterange"
            tabIndex={ rest.expanded ? 0 : -1 }
            buttonType="naked"
            ariaLabel={ intl.formatMessage({ id: 'GeneralDateFilter.ThisWeekButton.TitleAttribute', defaultMessage: '** Set date filter to this week’s dates' }) }
            label={ intl.formatMessage({ id: 'Appointments.AppointmentsList.Filter.Schedule.ThisWeek', defaultMessage: '** This week' }) }
            size="xsmall"
            onClick={ setThisWeekDate }
          />
          <Button
            testId="set-this-month-daterange"
            tabIndex={ rest.expanded ? 0 : -1 }
            buttonType="naked"
            ariaLabel={ intl.formatMessage({ id: 'GeneralDateFilter.ThisMonthButton.TitleAttribute', defaultMessage: '** Set date filter to this month’s dates' }) }
            label={ intl.formatMessage({ id: 'Appointments.AppointmentsList.Filter.Schedule.ThisMonth', defaultMessage: '** This month' }) }
            size="xsmall"
            onClick={ setThisMonthDate }
          />
        </div>

        <Row>
          <Col xs>
            <DatePicker
              ariaLabel={{ id: 'GeneralDateFilter.FromDateInput.TitleAttribute', defaultMessage: '** From date' }}
              label={{ id: 'Appointments.AppointmentsList.Filter.Schedule.From', defaultMessage: '** From' }}
              value={ startDate }
              maxDate={ endDate }
              onChange={ setStartDate }
            />
          </Col>

          <Col xs>
            <DatePicker
              ariaLabel={{ id: 'GeneralDateFilter.ToDateInput.TitleAttribute', defaultMessage: '** To date' }}
              label={{ id: 'Appointments.AppointmentsList.Filter.Schedule.to', defaultMessage: '** To' }}
              value={ endDate }
              minDate={ startDate }
              onChange={ setEndDate }
            />
          </Col>
        </Row>
      </div>
    </FilterItem>
  );
};

export default FilterByDateRange;
